import {CLIENT_APP_APP_STORE_LINK, CLIENT_APP_PLAY_STORE_LINK} from 'constants/Urls';
import IMAGES from 'constants/Images';
import React from 'react';
import styled from 'styled-components';

const OpsEvaluation = () => (
  <>
    <Wrapper>
      <HeadSection className="head-section">
        <Image
          className="profile-search-icon"
          src={IMAGES.profileCardSearch}
          height={150}
          width={150}
        />
        <MsgContainer>
          <Header className="body-large font-bold">Request Received</Header>
          <Text className="body-small text-black">
            We have received your request. Our team is currently verifying your information. If
            everything is confirmed, you will soon receive the eSign form in your registered Email
          </Text>
          <TimeDuration>
            <Image style={{marginRight: '8px'}} src={IMAGES.clockIcon} height={16} width={16} />
            It takes around 1 day for KYC to Authorize
          </TimeDuration>
        </MsgContainer>
      </HeadSection>
      <Divider />
      <LinksSection className="links-section">
        <DownloadAppTxt className="body-regular">
          Download the wealthy App <br /> enjoy efficient Trading experience
        </DownloadAppTxt>
        <DownloadIcons>
          <a href={CLIENT_APP_PLAY_STORE_LINK}>
            <Image className="store-icon" src={IMAGES.playStore} />
          </a>
          <a href={CLIENT_APP_APP_STORE_LINK}>
            <Image className="store-icon" src={IMAGES.appStore} />
          </a>
        </DownloadIcons>
      </LinksSection>
    </Wrapper>
  </>
);

export default OpsEvaluation;

const MsgContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const HeadSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const LinksSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  max-width: 480px;

  border: 1px solid ${(props) => props.theme.colors.brand.primary};
  border-radius: 8px;
  padding: 1.5rem 2rem 0rem 2rem;
  background-color: ${(props) => props.theme.colors.brand.secondary};
`;

const DownloadIcons = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;

  .store-icon {
    margin-right: 1rem;
    width: 120px;
    height: 120px;
    @media screen and (max-width: ${(props) => props.theme.breakpoints.md}) {
      width: 100px;
      height: 100px;
    }
  }
`;

const Image = styled.img``;

const Divider = styled.div`
  border-bottom: 1px dashed ${(props) => props.theme.colors.brand.primary};
  width: 100%;
  height: 4px;
  margin: 2rem 0;
`;

const DownloadAppTxt = styled.p`
  color: ${(props) => props.theme.colors.brand.primary};
  text-align: center;
  text-transform: capitalize;
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  height: 100%;
  position: relative;
  flex-direction: column;
  justify-content: center;
  padding: ${(props) => props.theme.spacing.sm};

  .head-section,
  .links-section {
    width: 100%;
  }
  .wealthy-logo {
    display: none;
  }
`;

const Header = styled.h1`
  text-align: center;
  color: ${(props) => props.theme.colors.brand.primary};
  margin-top: 0rem;
`;

const Text = styled.p`
  text-align: center;
  margin-bottom: ${(props) => props.theme.spacing.md};
  max-width: 640px;
`;

const TimeDuration = styled.p`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${(props) => props.theme.colors.brand.primary};
  font-family: ${(props) => props.theme.typography.fontFamily.primary};
  font-size: ${(props) => props.theme.typography.fontSize.xs};
  font-style: normal;
  font-weight: ${(props) => props.theme.typography.fontWeight.regular};
  line-height: 1.4;
  background-color: ${(props) => props.theme.colors.brand.secondary};
  padding: ${(props) => props.theme.spacing.sm};
  border-radius: ${(props) => props.theme.borderRadius.sm};
`;
